<template>
  <TableGradient
      icon-name="cubes"
      :title="$t('tipo.listagem.titulo_pagina')"
      :text-empty="$t('tipo.listagem.table.empty')"
      table-data
      route-new="tipo.create"
      :text-new="$t('tipo.listagem.novo')"
      :fields="fields"
      :fields-filter="filter"
      :items="types"
      :loading="isLoading"
      :paginator="types_pagination"
      @list="evt => $store.dispatch('type/listAllPaginated', evt)">
    <template v-slot:cell(values)="linha">
      <b-btn
        pill
        variant="light mr-2"
        size="sm"
        :to="{ name : 'tipo.value.create', params: {tipo_id: linha.item.id}}"
        ><i class="fas fa-plus"/>
      </b-btn>
      <b-btn variant="light mr-2" size="sm" pill @click="loadValues(linha)">
        <i class="fas fa-chevron-circle-down"/>
      </b-btn>
    </template>
    <template v-slot:row-details="{item}">
      <TableSimple
        :text-empty="$t('tipo.listagem.empty')"
        :fields="values_fields"
        :items="item.values || []"
        :loading="values_isLoading"
        :paginator="values_pagination"
        @paginate="paginateValues"
      >
        <template v-slot:cell(status)="{item: { status }}">
          <span
              :class="{'rounded-pill p-1 badge':true, 'badge-success': status, 'badge-danger': !status}">
              <em>
                {{ status ? $t('tipo.listagem.habilitado') : $t('tipo.listagem.desabilitado') }}
              </em>
          </span>
        </template>
        <template v-slot:cell(id)="{index, item}">
          <router-link
            :id="`link-edit-${index}`"
            :to="{ name: 'tipo.value.edit', params: { id: item.id }}"
            class="font-weight-bold"
          >{{ $t('tipo.listagem.table.editar') }}
          </router-link>
        </template>
      </TableSimple>
    </template>

    <template v-slot:cell(status)="linha">
      <span
          :class="{'rounded-pill p-1 badge':true, 'badge-success':linha.item.status, 'badge-danger': !linha.item.status}">
          <em v-if="linha.item.status">{{ $t('tipo.listagem.habilitado') }}</em>
          <em v-else>{{ $t('tipo.listagem.desabilitado') }}</em>
      </span>
    </template>
    <template v-slot:cell(id)="{index, item}">
      <router-link
        :id="`link-edit-${index}`"
        :to="{ name: 'tipo.edit', params: { id: item.id }}"
        class="font-weight-bold"
      >{{ $t('tipo.listagem.table.editar') }}
      </router-link>
    </template>
  </TableGradient>
</template>

<script>
import TableGradient from "@/templates/TableGradient";
import TableSimple from "@/components/TableSimple";
import {mapActions, mapGetters, mapMutations} from 'vuex';

export default {
  name: "Index",
  components: {TableGradient, TableSimple},
  computed: {
    ...mapGetters({
      types_storage: 'type/all',
      types_isLoading: 'type/isLoading',
      types_pagination: 'type/pagination',
      values: 'type/value/all',
      values_isLoading: 'type/value/isLoading',
      values_pagination: 'type/value/pagination',
    }),
    isLoading() {
      return !(this.mounted && this.types_isLoading === false)
    },
    types() {
      return this.types_storage.data || []
    }
  },
  data() {
    return {
      mounted: false,
      typeSelected: [],
      values_fields: [
        {key: 'name', label: this.$t('tipo.listagem.table.nome'), sortable: true},
        {key: 'code', label: this.$t('tipo.listagem.table.codigo'), sortable: true},
        {key: 'status', label: 'Status', sortable: true},
        {key: 'id', label: this.$t('tipo.listagem.table.editar')},
      ],
      fields: [
        {key: 'values', label: this.$t('tipo.listagem.table.valores')},
        {key: 'name', label: this.$t('tipo.listagem.table.nome'), sortable: true},
        {key: 'code', label: this.$t('tipo.listagem.table.codigo'), sortable: true},
        {key: 'status', label: 'Status', sortable: true},
        {key: 'id', label: this.$t('tipo.listagem.table.editar')},
      ],
      filter: [
        {key: 'name', label: this.$t('tipo.listagem.table.nome')},
        {key: 'code', label: this.$t('tipo.listagem.table.codigo')},
      ],
    }
  },
  methods: {
    ...mapActions([
      'type/listAllPaginated',
      'type/value/listAll',
    ]),
    ...mapMutations([
      'type/setAll',
      'type/value/setAll',
    ]),
    async loadValues(linha) {
      this.typeSelected = linha;
      linha.toggleDetails()
      if (!linha.detailsShowing) {
        await this['type/value/listAll']({ ...this.values_pagination, filters: [['mapping_type_id', '=', linha.item.id]]})
        const updated = this.types.map(t => t.id === linha.item.id ? { ...t, values: this.values } : {...t})
        this['type/setAll']({data: updated})
      }
    },
    async paginateValues(pagination) {
      await this.$store.commit('type/value/setPagination', {
        ...this.values_pagination,
        page: pagination.page,
        per_page: pagination.per_page
      })
      await this.loadValues(this.typeSelected)
    }
  },
  async mounted() {
    await this['type/listAllPaginated'](this.types_pagination)
    this.mounted = true
  },
  beforeDestroy() {
    this['type/setAll']([])
    this['type/value/setAll']([])
  }
}
</script>
